import { PER_COUNT } from '../../../components/PaginationButtons';
import SelectOption from '../../../components/bootstrap/Option';
import { CardActions } from '../../../components/bootstrap/Card';
import Select from '../../../components/bootstrap/forms/Select';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import { useMediaQuery } from '@mui/material';
import constantString from '../../../common/language/constantString';
import CustomSearchInput from '../../presentation/demo-pages/helper/CustomSearchInput';
import { useTranslation } from 'react-i18next';

const CommonActionHeader = ({ onKeyUp, onChange, perPage, preCount }) => {
	const { t } = useTranslation();
	const matches = useMediaQuery('(max-width:600px)');

	const _commonSpan = <span className='text-muted'>{t('Show')}</span>;

	const _commonSeachInput = (
		<FormGroup>
			<CustomSearchInput onSearch={onKeyUp} />
		</FormGroup>
	);

	const _commonSelector = (
		<Select size='sm' ariaLabel={t('Per')} onChange={onChange} value={perPage}>
			{Object.keys(preCount ?? PER_COUNT).map((i) => (
				<SelectOption key={i} value={i}>
					{i}
				</SelectOption>
			))}
		</Select>
	);

	return (
		<CardActions className='w-100'>
			{!matches ? (
				<div className='row align-items-center d-flex'>
					<div className='col-auto'>{_commonSpan}</div>
					<div className='col-auto px-0'>{_commonSelector}</div>
					<div className='col-auto ms-auto'>
						<div className='row align-items-center'>
							<div className='col'>{_commonSeachInput}</div>
						</div>
					</div>
				</div>
			) : (
				<div className='row align-items-center d-flex'>
					<div className='col-auto'>{_commonSpan}</div>
					<div className='col-auto px-0'>{_commonSelector}</div>
					<div className='col-6 col-md-auto ms-auto'>
						<div className='row align-items-center'>
							<div className='col'>{_commonSeachInput}</div>
						</div>
					</div>
				</div>
			)}
		</CardActions>
	);
};

export default CommonActionHeader;
